import axios from "axios";
import { User } from "../types/SettingsTypes";

const SERVICES_URL = window.MLBBest.envVariables.SERVICES_URL;
const API_URL = `${SERVICES_URL}`;

export const getUserInfo = (): Promise<User> => axios.get(`${API_URL}/userInfo`).then(response => response.data);
